import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";
import { ModalButton } from "@/views/components/Modal";
import { ConvertProfileModal } from "@/views/Settings/UserSettings/UserAccount/ConvertProfile";

export const ConvertProfileSettings: FC = () => {
  const { t } = useTranslation("session");

  const baseClass = "user-account-settings";

  return (
    <Section padding={["lg"]} borderRadius>
      <Flex className={baseClass} grow={1} direction="column" innerBorder={true} innerPadding="md">
        <Header
          size="sm"
          weight="bold"
          text={t("USERS.SETTINGS.USER_SETTINGS.TAB_NAME.CONVERT_PROFILE_TO_COMPANY_PROFILE")}
        />
        <Flex>
          <ModalButton openable={ConvertProfileModal} className={`${baseClass}__close-account-button`}>
            <Text>{t("USERS.SETTINGS.USER_ACCOUNT.CONVERT_PROFILE.BUTTON_CONVERT_PROFILE")}</Text>
          </ModalButton>
        </Flex>
      </Flex>
    </Section>
  );
};
